import React from 'react';
import './PictureText.css';
import { Container, Row, Col } from 'bootstrap-4-react';
import Slide from 'react-reveal/Slide';

class PictureText extends React.Component{
    
    render() {
        let align = this.props.align;
        let picture = this.props.picture;
        let text = this.props.text;
        let sectionTitle = this.props.sectionTitle;
        let subtitle = '';
        if (this.props.subtitle) {
             subtitle = this.props.subtitle;
        }
        let col = "md-5 12";
        let offset = "md-1";
        let col2 = "md-6 12";
        let contentLeft = (
            <div className="text-left">
                <h3>{sectionTitle}</h3>
                <p>{text}</p>
            </div>
        );
        let contentRight = (
            <div>
                <img src={picture} width="100%" />
            </div>  
        )
        
        if (align === 'right') {
            col="md-5 12";
            offset="";
            col2="md-6 12";
            contentLeft = (
                <div>
                    <img src={picture} width="100%" />
                </div>  
            )
            contentRight = (
                <div className="text-right">
                    <h3>{sectionTitle}</h3>
                    <h4>{subtitle}</h4>
                    {text}
                </div> 
            )
        }
       return (
        <section className="picture-text">
            <Container>
                <Row>
                    <Col col={col} offset={offset}>
                        <Slide left>
                            {contentLeft}
                        </Slide>
                    </Col>
                    <Col col={col2}>
                        <Slide right>
                            {contentRight}
                        </Slide>
                    </Col>      
                </Row>
            </Container>
        </section>
       );
    }
}
export default PictureText;